/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaxCheckAddAddressResult } from './PaxCheckAddAddressResult';
import {
    PaxCheckAddAddressResultFromJSON,
    PaxCheckAddAddressResultFromJSONTyped,
    PaxCheckAddAddressResultToJSON,
    PaxCheckAddAddressResultToJSONTyped,
} from './PaxCheckAddAddressResult';
import type { PaxCheckErrorContainer } from './PaxCheckErrorContainer';
import {
    PaxCheckErrorContainerFromJSON,
    PaxCheckErrorContainerFromJSONTyped,
    PaxCheckErrorContainerToJSON,
    PaxCheckErrorContainerToJSONTyped,
} from './PaxCheckErrorContainer';

/**
 * 
 * @export
 * @interface PaxCheckAddAddressResponse
 */
export interface PaxCheckAddAddressResponse {
    /**
     * 
     * @type {PaxCheckAddAddressResult}
     * @memberof PaxCheckAddAddressResponse
     */
    data?: PaxCheckAddAddressResult;
    /**
     * 
     * @type {PaxCheckErrorContainer}
     * @memberof PaxCheckAddAddressResponse
     */
    error?: PaxCheckErrorContainer;
}

/**
 * Check if a given object implements the PaxCheckAddAddressResponse interface.
 */
export function instanceOfPaxCheckAddAddressResponse(value: object): value is PaxCheckAddAddressResponse {
    return true;
}

export function PaxCheckAddAddressResponseFromJSON(json: any): PaxCheckAddAddressResponse {
    return PaxCheckAddAddressResponseFromJSONTyped(json, false);
}

export function PaxCheckAddAddressResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckAddAddressResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : PaxCheckAddAddressResultFromJSON(json['data']),
        'error': json['error'] == null ? undefined : PaxCheckErrorContainerFromJSON(json['error']),
    };
}

export function PaxCheckAddAddressResponseToJSON(json: any): PaxCheckAddAddressResponse {
    return PaxCheckAddAddressResponseToJSONTyped(json, false);
}

export function PaxCheckAddAddressResponseToJSONTyped(value?: PaxCheckAddAddressResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': PaxCheckAddAddressResultToJSON(value['data']),
        'error': PaxCheckErrorContainerToJSON(value['error']),
    };
}

